import type {NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import type {EnclosingRichText} from './richTextScope';

export const resolveEvaluatedOverlayTarget = (
  target: unknown,
  instanceIndexSuffix: unknown,
  nativeIdPath: readonly NativeId[],
  triggerElementId?: string,
  enclosingRichText?: EnclosingRichText
): string | null => {
  if (typeof target === 'string') {
    return target || null;
  }

  if (typeof target === 'function') {
    const result = target(
      typeof instanceIndexSuffix === 'string' ? instanceIndexSuffix : undefined,
      nativeIdPath,
      triggerElementId,
      enclosingRichText
    );
    return typeof result === 'string' && result ? result : null;
  }

  return null;
};
